import { AlertCriterion } from '@vestiaire/api-sdk-angular';

export class AlertCriterionCollection {
  private _criterions: AlertCriterion[] = [];

  public addCriterion(criterion: AlertCriterion) {
    let criterionFounded = false;

    this._criterions.map((item, idx) => {
      if (item.key === criterion.key) {
        criterionFounded = true;
        this._criterions[idx].value = [...this._criterions[idx].value, ...criterion.value];
      }
    });

    if (!criterionFounded) {
      this._criterions.push(criterion);
    }
  }

  public getList(): AlertCriterion[] {
    return this._criterions;
  }
}
